import { render, staticRenderFns } from "./veStuFamilyEdit.vue?vue&type=template&id=022b9f48&scoped=true"
import script from "./veStuFamilyEdit.vue?vue&type=script&lang=js"
export * from "./veStuFamilyEdit.vue?vue&type=script&lang=js"
import style0 from "./veStuFamilyEdit.vue?vue&type=style&index=0&id=022b9f48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022b9f48",
  null
  
)

export default component.exports